export default "__VITE_ASSET__BYMt54eQ__"